import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'active-alarms',
  templateUrl: './active-alarms.component.html',
  styleUrls: ['./active-alarms.component.scss']
})
export class ActiveAlarmsComponent implements OnInit {
  alarmsTypes;
  totalAlarms;

  @Input()
  set items(alarmsTypes: any) {
    if (_.isNil(alarmsTypes)) { return; }

    const arrayOfValues = alarmsTypes.map(alarm => alarm.count);
    this.totalAlarms = _.sum(arrayOfValues);
    this.alarmsTypes = alarmsTypes;
  }

  constructor() { }

  ngOnInit(): void {
  }
}
